import { AMOUNT_HINT_ATTRIBUTE } from "@/helpers/money"

const HINT_SELECTOR = `[${AMOUNT_HINT_ATTRIBUTE}]`

interface IClosestTarget {
  closest(selector: string): unknown
}

const hasClosest = (target: unknown): target is IClosestTarget =>
  typeof target === "object" &&
  target !== null &&
  typeof (target as IClosestTarget).closest === "function"

export const toggledOpenCode = (
  open: string | null,
  code: string
): string | null => (open === code ? null : code)

export const isOutsideHint = (target: unknown): boolean =>
  !hasClosest(target) || target.closest(HINT_SELECTOR) === null
